<mwe-basic-card-bodyless
  [cardClass]="noRadiusBottom ? 'rounded-bottom-0' : ''"
  [height100]="height100"
  [noBoxShadow]="noBoxShadow"
  data-test="mwe-multi-product-card"
>
  <div class="card-basic-body flex-grow-0 my-auto">
    @if (card?.categories?.length > 0) {
      <div class="row gx-3 justify-content-center">
        @for (category of card.categories; track category) {
          <div class="col-auto text-center">
            <mwe-product-icon [category]="category" size="lg" textNodeType="p" />
            @if (showCompanyReference) {
              <p class="text--legal mb-0 mt-1">
                {{ card.categories[0] | correlatedCompanyReference }}
              </p>
            }
          </div>
        }
      </div>
    }
    <div class="text-center">
      <div class="mt-3" data-test="multi-product-card-account-customer-number">
        @if (isAccountNumberVisible()) {
          <p [innerHTML]="'shared.accountNumber_2' | translate: { accountNumber: card.accountNumber } | safeHtml"></p>
        }
        @if (isCustomerNumberVisible()) {
          <p>{{ 'shared.customerNumber' | translate: { customerNumber: card.customerNumber } }}</p>
        }
      </div>
      @if (showSummarizedCompanyReference && !showCompanyReference && card?.categories?.length > 0) {
        <p class="text--legal mb-0 mt-2">
          {{ card.categories[0] | correlatedCompanyReference }}
        </p>
      }
    </div>
  </div>
  <ng-content />
</mwe-basic-card-bodyless>
